export const API_ENDPOINT = 'https://api.capacitaciones.centracom.com.gt/v1'
